export const SubstractMonth = () => {
  const month = new Date().setMonth(new Date().getMonth() - 1);
  return month;
};
